<div class="admin-component-container">
  <div class="d-flex flex-wrap col-md-12 text-center">
    <div class="col-md-4" *ngFor="let item of sectionComponentsData">
      <div class="custom-card">
        <cx-media [container]="item.media" class="img-styles" loading="lazy"/>
        <div>
          <strong class="card-title">{{ item.name }}</strong>
          <div class="card-content" [innerHTML]="item.imageMapHTML"></div>
        </div>
        <button class="btn btn-outline-primary" (click)="clickActionOfCard(item.urlLink)">{{item.cta}}</button>
      </div>
    </div>
  </div>
</div>
